import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import './Card.css';

export default function VideoGen() {
  const { token, hasApiKey } = useOutletContext();
  const [prompt, setPrompt] = useState('A horse galloping through a sunlit meadow');
  const [status, setStatus] = useState('');
  const [videoUrl, setVideoUrl] = useState(null);

  const generate = async () => {
    setStatus('Generating video (may take a minute)...');
    try {
      const res = await fetch('/api/generate-video', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ prompt })
      });
      if (!res.ok) throw new Error(await res.text());
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      setVideoUrl(url);
      setStatus('Video ready!');
    } catch (err) {
      setStatus(`Error: ${err.message}`);
    }
  };

  return (
    <div className="card">
      <div className="card-title">
        <i className="fas fa-video"></i> Video Generation
      </div>
      <label>Prompt</label>
      <input value={prompt} onChange={e => setPrompt(e.target.value)} />
      <button onClick={generate} disabled={!hasApiKey}>Generate Video</button>
      <div className="status-badge">{status}</div>
      {videoUrl && <video src={videoUrl} controls className="preview-img" />}
    </div>
  );
}
